import { FC } from 'react'

export const NoContent: FC = () => {
  return (
    <div
      className="spec-card-content"
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        height: '100%',
      }}
    >
      <div className="flex flex-col w-full md:w-[115px] items-start">
        <p className="text-base font-bold text-tdplprussian">No Content</p>
      </div>
      <div className="flex flex-col w-full md:w-[100px] justify-center"></div>
    </div>
  )
}
